module.exports = __webpack_public_path__ + "img/filter-new.63ad7227.svg";